import {doGet, doPost} from './FetchWrapper';
import {getKeys} from "../utils/APIUtil";

export const search = (args) => {
    return doGet(`/api/?event=calendar.search${getKeys(args)}`)
};
